type Props = {
  isOpened?: boolean;
};

export const HigherGradeEnvelopeIcon = ({ isOpened }: Props) => {
  if (isOpened) {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="26"
        height="29"
        viewBox="0 0 26 29"
        fill="none"
        aria-hidden
      >
        <path
          d="M1.5 10.333V25.9997C1.5 26.552 1.94771 26.9997 2.5 26.9997H22.7222C23.2745 26.9997 23.7222 26.552
          23.7222 25.9997V10.333"
          stroke="#0069E4"
          strokeWidth="3"
          strokeLinecap="round"
        />
        <path
          d="M23.7227 10.3018L12.9799 2.44184C12.6217 2.17973 12.1335 2.18515 11.7812 2.45513L1.50043 10.333"
          stroke="#0069E4"
          strokeWidth="3"
        />
        <path
          d="M23.7227 13.1113L12.9119 20.1547C12.5736 20.3751 12.1358 20.3704 11.8023 20.1428L1.50043 13.1113"
          stroke="#0069E4"
          strokeWidth="3"
        />
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29"
      height="22"
      viewBox="0 0 29 22"
      fill="none"
    >
      <rect
        x="2"
        y="2"
        width="24.5711"
        height="19.1109"
        rx="1"
        fill="#0069E4"
      />
      <path
        d="M1 2L14.1427 13.4169C14.5255 13.7494 15.0966 13.7428 15.4716 13.4015L28 2"
        stroke="#F1F5FB"
        strokeWidth="3"
      />
    </svg>
  );
};
